export function getTenantIdFromHost(hostname = window.location.hostname) {
  // arcus.kundresa.com -> "arcus"
  // localhost -> "local"
  const parts = hostname.split(".");

  //console.log(hostname)

  // localhost / IP / dev
  if (hostname === "localhost" || /^\d+\.\d+\.\d+\.\d+$/.test(hostname)) {
    //return "local";
    //console.log("localhost" + hostname);
  return "arcus";
   return "root";
   return "localhost";
  }

  // arcus.kundresa.com => ["arcus","kundresa","com"]
  // kundresa.com => ["kundresa","com"] (ingen subdomain)
  //console.log("localhost" + parts[0]);
  if (parts.length >= 3) return parts[0];

  
//console.log("root");
  return "root"; // kundresa.com utan subdomain
}